const TIME = {
  MINUTE: 60_000,
  HOUR: 3_600_000,
  DAY: 86_400_000,
  WEEK: 604_800_000,
} as const

export const CACHE_PROFILES = {
  lookup: {
    staleTime: 5 * TIME.MINUTE,
    gcTime: 15 * TIME.MINUTE,
    refetchOnMount: false as const,
    refetchOnWindowFocus: false as const,
  },
  standard: {
    staleTime: 2 * TIME.MINUTE,
    gcTime: 10 * TIME.MINUTE,
  },
  active: {
    staleTime: 30_000,
    gcTime: 5 * TIME.MINUTE,
  },
  realtime: {
    staleTime: 0,
    gcTime: TIME.MINUTE,
  },
} as const
